 export function handleRatingDisplayChanges(resetLink: HTMLElement | null) {
    const ratingText = document.getElementById('ratingText');
    const ratingsInfo = document.getElementById('ratingsInfo');
    if(resetLink?.classList.contains("hidden")){
      resetLink?.classList.remove("hidden");
      resetLink.classList.add('reset-text');
      if(ratingText){
        ratingText.textContent = 'Showing:';
        ratingText.classList.remove('ratings-text');
        ratingText.classList.add('showing-text');
        ratingsInfo?.classList.remove('ratings-info');
        ratingsInfo?.classList.add('hidden');
      }
    }
  }